import React from "react"
import badge from "badges/newbie.svg"
import { BadgeImage } from "backpack/badges/styled"

const Newbie = props => <BadgeImage src={badge} {...props} />

export default Newbie
